import { ICluster, IContact } from '@nkr/models/index';
import JoditEditor from '@nkr/components/editor';
import config from '@nkr/views/ticketing/jodit-editor-config';
import Swaps from '../common/swaps';
import SwapManager from '../common/swap-manager';

interface IProps {
    message: string,
    swaps: ICluster[],
    swapManager: IContact,
    onMessageChange: (message: string) => void
}

const ByCluster = (props: IProps) => {
    const handleMessageChange = (message: string) => {
        props.onMessageChange(message);
    };

    const joditConfig = { ...config, height: '300px' };

    const hasClc = props.swaps.filter(x => x.positions.filter(p => p.hasClc).length > 0).length > 0;

    return (
        <>
            <JoditEditor
                value={props.message}
                config={joditConfig}
                onChange={handleMessageChange}
                onBlur={() => null}
            />
            <br />

            <div style={{ marginBottom: 5 }}><strong>Match Offer</strong></div>

            <Swaps includePreselectStatus={true} swaps={props.swaps} />

            <div style={{ marginBottom: 5 }}><strong>Swap Manager</strong></div>

            <SwapManager data={props.swapManager} />
        </>
    );
}

export default ByCluster;